import { useState } from 'react';
import MassActionRequestConfig from './requestBuilder/MassActionRequestConfig';
import ColumnsSelector from './resultfieldsSelector/ColumnsSelector';
import MassActionRequestResult from './requestResultList/MassActionRequestResult';
import MassActionContentSelector from './massActionMessage/MassActionContentSelector';
import MassActionMessage from './massActionMessage/MassActionMessage';
import NotFound from 'src/components/common/NotFound';
import { useRoute } from 'wouter';
import { useCampaignEditor } from 'src/components/massAction/state/massAction';
import Loader from 'src/components/common/Loader';
import { useTranslation } from 'react-i18next';
import { useMassActionState } from '../MassActionStateContext';

// Etapes de l'éditeur de campagnes ponctuelles
// TODO step mechanism will be moved to a context, provided to top component (MassActionContent) so it can be used in MassActionRequestList too (need to display resultList step on execute action)
export const [REQUEST_CONFIG, COLUMS_SELECTOR, REQUEST_RESULTS, CONTENT_SELECTOR, CONTENT] = [
  'config',
  'col_select',
  'result',
  'content_select',
  'content',
];

const MassActionEditor = props => {
  const [currentStep, goToStep] = useState(REQUEST_CONFIG);
  const [extraProps, setExtraProps] = useState({});

  const [, editRouteParams] = useRoute('/oneoff/:id/edit') as [any, { id: string }];
  const loaded = useCampaignEditor(Number(editRouteParams?.id));

  const { t } = useTranslation();

  function enhancedGoToStep(step, newExtraProps) {
    setExtraProps(newExtraProps || {});
    goToStep(step);
  }

  // TODO deplacer dans react state ce qui est relatif aux données de la campagne (name, replay, bypass, selectedCriterias, selectedResultfields)
  const [
    {
      currentName,
      currentReplay,
      currentByPass,
      selectedCriterias,
      currentMassActionId,
      selectedResultfields,
      // this data will not be migrated to form state (not used to POST/PUT a campaign)
      availableCriterias,
      availableResultfields,
      isWritable,
    },
    setMassActionState,
  ] = useMassActionState();

  const mergedProps = {
    currentName,
    currentReplay,
    currentByPass,
    selectedCriterias,
    currentMassActionId,
    selectedResultfields, // resultFieldSelection
    setMassActionState,
    // this data does not concern the form state
    availableCriterias,
    availableResultfields,
    isWritable,
    // below are not from redux
    currentStep,
    goToStep: enhancedGoToStep,
    ...props,
    ...extraProps,
  };

  if (!loaded)
    return (
      <div>
        <Loader wrapperClass="ghostWrapperClass" text={t('smartmessaging.loading')} />
      </div>
    );

  // TODO ne passer que les props necessaires à chaque composant
  switch (currentStep) {
    case REQUEST_CONFIG:
      return <MassActionRequestConfig {...mergedProps} />;
    case COLUMS_SELECTOR:
      return <ColumnsSelector {...mergedProps} />;
    case REQUEST_RESULTS:
      return <MassActionRequestResult {...mergedProps} />;
    case CONTENT_SELECTOR:
      return (
        <MassActionContentSelector
          {...mergedProps}
          handleSelectContent={campaignAction => {
            setMassActionState(state => ({
              ...state,
              currentCampaignAction: campaignAction,
            }));
          }}
        />
      );
    case CONTENT:
      return (
        <MassActionMessage
          actionId={currentMassActionId}
          goToStep={goToStep}
          isWritable={isWritable}
          // TODO detailler les extraProps que reçcoit MassActionMessage, et pareil pour tous les composants
          {...extraProps}
        />
      );
    default:
      return <NotFound />;
  }
};

export default MassActionEditor;
